import { OrderStatuses } from 'constants/orderStatuses';
import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useGetOne, useShowController } from 'react-admin';
import { Box } from 'shared/mui/Box';

import { StyledLeftColumnBox, StyledRightColumnBox } from './OrdersShowCommonInfo.styled';
import { OrdersShowCommonInfoAdjustments } from './OrdersShowCommonInfoAdjustments/OrdersShowCommonInfoAdjustments';
import { OrdersShowCommonInfoConfirmation } from './OrdersShowCommonInfoConfirmation/OrdersShowCommonInfoConfirmation';
import { OrdersShowCommonInfoMain } from './OrdersShowCommonInfoMain/OrdersShowCommonInfoMain';
import { OrdersShowCommonInfoMerchant } from './OrdersShowCommonInfoMerchant/OrdersShowCommonInfoMerchant';
import { OrdersShowCommonInfoProvider } from './OrdersShowCommonInfoProvider/OrdersShowCommonInfoProvider';
import { OrdersShowCommonInfoResources } from './OrdersShowCommonInfoResources/OrdersShowCommonInfoResources';
import { OrdersShowCommonInfoState } from './OrdersShowCommonInfoState/OrdersShowCommonInfoState';
import { OrdersShowCommonInfoStatuses } from './OrdersShowCommonInfoStatuses/OrdersShowCommonInfoStatuses';
import { OrdersShowCommonInfoTransactions } from './OrdersShowCommonInfoTransactions/OrdersShowCommonInfoTransactions';

export const OrdersShowCommonInfo = (): JSX.Element => {
  const { hasResourceAccess } = usePermissions();
  const { record } = useShowController();

  const { data: orderStatus } = useGetOne(
    'order_statuses',
    {
      id: record?.status?.['@id'] || '',
    },
    {
      enabled: !!record,
    },
  );

  return (
    <Box style={{ display: 'flex', flexDirection: 'row', paddingBottom: '24px' }}>
      <StyledLeftColumnBox>
        <OrdersShowCommonInfoState />
        <OrdersShowCommonInfoMain />
        {hasResourceAccess(Resources.Merchants) && <OrdersShowCommonInfoMerchant />}
        {hasResourceAccess(Resources.Providers) && <OrdersShowCommonInfoProvider />}
        {(hasResourceAccess('order_action_urls') ||
          hasResourceAccess('order_notification_urls')) && <OrdersShowCommonInfoResources />}
      </StyledLeftColumnBox>
      <StyledRightColumnBox>
        {orderStatus?.value === OrderStatuses.WaitingConfirmation && (
          <OrdersShowCommonInfoConfirmation />
        )}
        {hasResourceAccess('transactions') && <OrdersShowCommonInfoTransactions />}
        {hasResourceAccess('order_status_histories') && <OrdersShowCommonInfoStatuses />}
        {hasResourceAccess(Resources.OrderAdjustments) && <OrdersShowCommonInfoAdjustments />}
      </StyledRightColumnBox>
    </Box>
  );
};
